import { render, staticRenderFns } from "./YoungDetailsHeader.vue?vue&type=template&id=197410b6&"
import script from "./YoungDetailsHeader.vue?vue&type=script&lang=js&"
export * from "./YoungDetailsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports